export const CountryOptionList = [
  { title: "Canada", value: "CA" },
  { title: "Mexico", value: "MX" },
  { title: "United States", value: "US" },
];
